module.exports = __webpack_public_path__ + "static/img/Wechat.1c821de.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Wechat.jpeg
// module id = bVJN
// module chunks = 1